import avatar from "./image-avatar.png";
import logo from "./logo.svg";
import homeNav from "./icon-nav-home.svg";
import moviesNav from "./icon-nav-movies.svg";
import seriesNav from "./icon-nav-tv-series.svg";
import bookmarkNav from "./icon-nav-bookmark.svg";
import lens from "./icon-search.svg";
import iconBookmarkEmpty from "./icon-bookmark-empty.svg";
import iconBookmarkFull from "./icon-bookmark-full.svg";

const data = {
  avatar,
  logo,
  homeNav,
  moviesNav,
  seriesNav,
  bookmarkNav,
  lens,
  iconBookmarkEmpty,
  iconBookmarkFull,
};

export default data;
